module.exports = __webpack_public_path__ + "media/images/proposal/top/proposal-og-image-417dec6983b9a281a62d182ecd4ff189.png";